<header obg-app-m-header-container test-id="app-header" (search)="handleSearch()"></header>
<div
	class="obg-m-core-layout-content"
	test-id="pnp-mode-selector"
	[style.margin-top]="marginTop"
	[style.height]="height"
>
	<ng-scrollbar [obgScrollToTop]="scrollToTopOptions" [pointerEventsMethod]="'scrollbar'">
		<div class="obg-m-core-layout-outlet">
			<router-outlet></router-outlet>
		</div>
		<ng-container *ngIf="showFabricFooter$ | async; then fabricFooter; else angularFooter"> </ng-container>

		<ng-template #angularFooter>
			<obg-footer-container
				[breadcrumbList]="breadcrumbData$ | async"
				[hideSeo]="!showSeoFooter"
			></obg-footer-container>
		</ng-template>

		<ng-template #fabricFooter>
			<ng-container class="footer-v2-container" *ngIf="translations$ | async as translations">
				<site-footer_v2
					[translations]="translations"
					(footerButtonClick)="handleSupportButton($event)"
				></site-footer_v2>
			</ng-container>
		</ng-template>
	</ng-scrollbar>
</div>
